<div class="header-container">
  <div class="logo-container">
   <img class="image" src="../../../../assets/images/aau_logo.png" (click)="navigateHome()">
    <a class="logo" href="#" (click)="navigateHome()">C R M S</a>
  </div>
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
</div>

<div class="header-container">
  <nb-actions size="small">

    <nb-action>
      <button class="btn-setting"  nbButton ghost status="primary" (click)="goToCurriculum()">
       Manage
      </button>
    </nb-action>

    <nb-action>
      <button class="btn-setting"  nbButton ghost status="primary" (click)="compareBtn()">
       Compare
      </button>
    </nb-action>
    <nb-action class="user-action" >

      <button class="btn-setting"  nbButton ghost status="primary" [nbPopover]="templateRef">
       Report
      </button>
      <ng-template #templateRef>
        <!-- <div>
          <button nbButton ghost status="primary" (click)="departmentReview()">Department Form</button>
        </div>
        <div>
          <button nbButton ghost status="primary" (click)="programReview()">Program Form</button>
        </div> -->
        <div>
          <button class="btn-setting"  nbButton ghost status="primary" [nbPopover]="cluster">
          Cluster
          </button>
          <ng-template #cluster>
            <div>
              <button nbButton ghost status="primary" (click)="excutiveSummaryBtn()">Master Excutive Summary</button>
            </div>
            <div>
              <button nbButton ghost status="primary" (click)="departmentReview()">Department And Program</button>
            </div>
            <div>
              <button nbButton ghost status="primary"  (click)="dashboardBtn()">Cluster Report</button>
            </div>
            <!-- <div>
              <button nbButton ghost status="primary" (click)="programReview()">Program Form</button>
            </div> -->

          </ng-template>
        </div>
        <div>
          <button nbButton ghost status="primary" (click)="similarityReportBtn()">Comparison</button>
        </div>
        <!-- <div>
          <button nbButton ghost status="primary" (click)="excutiveSummaryBtn()">Excutive Summary</button>
        </div> -->

      </ng-template>
    </nb-action>

    <nb-action class="user-action"  *ngIf="!notAllowedToSee()">

        <button class="btn-setting"  nbButton ghost status="primary" [nbPopover]="templateRef">
          <i class="pi pi-cog"></i>
        </button>
        <ng-template #templateRef>
          <div>
            <button nbButton ghost status="warning" (click)="home()">Dashboard</button>
          </div>
          <div>
            <button  nbButton ghost status="warning" (click)="collegeFormBtn()">Colleges</button>
          </div>
          <div>
            <button nbButton ghost status="warning" (click)="departmentFormBtn()">Departments</button>
          </div>
          <div>
            <button nbButton ghost status="warning" (click)="userBtn()">Users</button>
          </div>
          <div>
            <button nbButton ghost status="warning" (click)="clusterBtn()">Clusters</button>
          </div>
          <div>
            <button nbButton ghost status="warning" (click)="importCourseBtn()">Import Courses</button>
          </div>
        </ng-template>
    </nb-action>
    <nb-action class="user-action"  *ngIf="notAllowedToSee()">

      <button class="btn-setting"  nbButton ghost status="primary" [nbPopover]="templateRef">
        <i class="pi pi-cog"></i>
      </button>
      <ng-template #templateRef>
        <div>
          <button nbButton ghost status="warning" (click)="home()">Dashboard</button>
        </div>
        <!-- <div>
          <button  nbButton ghost status="warning" (click)="collegeFormBtn()">Add College</button>
        </div>
        <div>
          <button nbButton ghost status="warning" (click)="departmentFormBtn()">Add Department</button>
        </div> -->
        <div>
          <button nbButton ghost status="warning" (click)="importCourseBtn()">Import Courses</button>
        </div>
      </ng-template>
  </nb-action>






    <!-- <nb-action>

      <button [nbSpinner] = "excelLoading" nbTooltip="Download report" nbTooltipStatus="success"   nbButton ghost status="success" [nbPopover]="templateRef2" >
        <i class="pi pi-download"></i>
      </button>
      <ng-template #templateRef2>
        <div>
          <button nbButton ghost status="success" (click)="downloadExcel()">Course</button>
        </div>
        <div>
          <button nbButton ghost status="success" (click)="downloadProgramExcel()">Program</button>
        </div>
      </ng-template>
    </nb-action> -->

    <nb-action>
      <button class="btn-setting"  nbButton ghost status="danger" (click)="logout()">
        <i class="pi pi-sign-out"></i>
      </button>
    </nb-action>
  </nb-actions>
</div>
